// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bg-v2-primary{--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity));background:linear-gradient(180deg,#00adb5,#03709f)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
